export enum CopyCropFieldsToManureSpaceEvents {
  CopyCropFieldsToManureSpaceStarted = 'Arable_CopyCropFieldsToManureSpaceStarted',
  CopyCropFieldsToManureSpaceCompleted = 'Arable_CopyCropFieldsToManureSpaceCompleted',
}

export interface CopyCropFieldsToManureSpaceState {
  amountOfCropFieldsCopying?: number;
  amountOfCropFieldsCompleted?: number;
  copyDialogDismissed?: boolean;
  copyStatusDismissed?: boolean;
}

export interface CopyCropFieldsToManureSpaceStarted {
  amountOfCropFields: number;
}

export interface CopyCropFieldsToManureSpaceCompleted {
  isSuccessful: boolean;
  message?: string;
}
